// extracted by mini-css-extract-plugin
export default {"cardBody":"CardFade_cardBody__6pY-w","success":"CardFade_success__pO7aG","warning":"CardFade_warning__Y1QnV"};